<template>
  <v-row>
    <v-col cols="12">
      <v-card class="terms-card" flat>
        <!-- HEADER BAND -->
        <div class="terms-header pl-base-bg">
          <div class="terms-header-icon">
            <v-icon color="#fff" size="22">mdi-file-document-edit-outline</v-icon>
          </div>
          <div>
            <div class="terms-title">Terms and Conditions</div>
            <div class="terms-subtitle">Shown to customers on your invoices</div>
          </div>
        </div>

        <!-- FORM -->
        <v-form ref="form" v-model="valid" class="pa-6">
          <v-row dense>
            <v-col cols="12">
              <v-textarea
                v-model="form.content"
                label="Terms & Conditions"
                outlined
                rows="10"
                auto-grow
                prepend-inner-icon="mdi-text"
              />
            </v-col>
          </v-row>

          <!-- ACTIONS -->
          <v-row v-if="isOwner" class="mt-4" justify="end" align="center" no-gutters>
            <v-btn color="secondary" @click="reset">Reset</v-btn>

            <v-btn
              class="terms-save-btn ml-3"
              :loading="loading"
              @click="submit"
            >
              Save Terms
            </v-btn>
          </v-row>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "TermsAndConditions",

  data() {
    return {
      valid: false,
      loading: false,
      form: {
        content: "",
      },
      rules: {
        required: (v) => !!v || "Required",
      },
    };
  },

  computed: {
    // ✅ FIXED: use terms module
    terms() {
      return this.$store.getters["terms/terms"];
    },
  },

  created() {
    this.loadTerms();
  },

  methods: {
    // ✅ FIXED: use terms module
    ...mapActions("terms", ["getTerms", "saveTerms"]),

    async loadTerms() {
      try {
        await this.getTerms();

        if (this.terms) {
          this.form.content = this.terms.content || "";
        }
      } catch (err) {
        console.error("LOAD_TERMS_ERROR:", err);
      }
    },

    async submit() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      try {
        await this.saveTerms(this.form);

        this.$toast?.success("Terms & Conditions saved successfully");
      } catch (err) {
        this.$toast?.error(
          err?.response?.data?.message || "Failed to save Terms & Conditions",
        );
      } finally {
        this.loading = false;
      }
    },

    reset() {
      if (this.terms) {
        this.form.content = this.terms.content || "";
      }
    },
  },
};
</script>

<style scoped>
.terms-card {
  border-radius: 0;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(15, 30, 50, 0.1);
}

.terms-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 20px;
}

.terms-header-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.terms-title {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.01em;
}

.terms-subtitle {
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.75);
  margin-top: 2px;
}

.terms-save-btn {
  background: var(--pl-base-bg-gradient) !important;
  color: #fff !important;
  font-weight: 700 !important;
  text-transform: none !important;
  box-shadow: none !important;
}
</style>
